import { Routes } from '@angular/router';

export const COURSE_ROUTES: Routes = [
  { path: ':id', loadComponent: () => import('./components/view/course-view.component').then(m => m.CourseViewComponent) },
  { path: '', loadComponent: () => import('./components/view/course-view.component').then(m => m.CourseViewComponent) }
];
